// Firebase initialization
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator, enableNetwork, disableNetwork } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBA3lcwFkph5k3mvSbcnHkeLN7XxuyS-nA",
  authDomain: "pythagoreschool-dc2f8.firebaseapp.com",
  projectId: "pythagoreschool-dc2f8",
  storageBucket: "pythagoreschool-dc2f8.firebasestorage.app",
  messagingSenderId: "844183169199",
  appId: "1:844183169199:web:778c39f4b026d3b2be0c5a",
};

// Initialize Firebase with error handling
let app;
let auth;
let db;
let storage;

try {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
  storage = getStorage(app);
  
  // Set Firestore settings for better offline support and retry logic
  db.settings = {
    cacheSizeBytes: 50000000, // 50 MB cache size
    ignoreUndefinedProperties: true,
    merge: true
  };
  
  console.log("Firebase initialized successfully");
} catch (error) {
  console.error("Error initializing Firebase:", error);
}

// Function to handle connection state
export const handleConnectionState = async (online) => {
  if (!db) return;
  
  try {
    if (online) {
      await enableNetwork(db);
      console.log("Firebase connection enabled");
    } else {
      await disableNetwork(db);
      console.log("Firebase connection disabled - working offline");
    }
  } catch (error) {
    console.error("Error managing Firebase connection:", error);
  }
};

// Function to retry Firebase operations
export const retryOperation = async (operation, maxRetries = 3) => {
  let retries = 0;
  while (retries < maxRetries) {
    try {
      return await operation();
    } catch (error) {
      retries++;
      console.log(`Operation failed, retry ${retries}/${maxRetries}`);
      if (retries >= maxRetries) throw error;
      await new Promise(resolve => setTimeout(resolve, 1000 * retries)); // Exponential backoff
    }
  }
};

export { app, auth, db, storage, firebaseConfig };
